module.exports = __webpack_public_path__ + "static/media/nortification_list.66014e32.svg";